module.exports = __webpack_public_path__ + "img/bobuv_bobocoin.gm.0f4a43c.png";